import { React, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import AdminSidebar from "../components/AdminSidebar";
import Loading from "../views/Loading";

export default function AdminMedication() {
  const [editMode, setEditMode] = useState(false);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState("");
  const [ready, setReady] = useState(false);

  const [medications, setMedications] = useState([]);
  const [newMedication, setNewMedication] = useState({
    name: "",
    brand: "",
    dosage: "",
    fee: "",
  });
  const [editMedication, setEditMedication] = useState(null);

  const fetchMedications = () => {
    fetch(`${process.env.REACT_APP_API}/clinic/medications`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          setMedications(response.medications);
        } else {
          setMessage(response.message);
        }
      })
      .catch((error) => {
        console.error(error);
        setMessage("Some Error Occured. Please Try Again Later");
      })
      .finally(() => setReady(true));
  };

  const handleSubmit = () => {
    if (editMode) {
      setReady(false);
      fetch(
        `${process.env.REACT_APP_API}/clinic/medications/${editMedication.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: JSON.stringify(editMedication),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.success) {
            setEditMode(false);
            setEditMedication(null);
            setSuccess("Medication saved successfully");
            fetchMedications();
          } else {
            setMessage(response.message);
          }
        })
        .catch((error) => {
          console.error(error);
          setMessage("Some Error Occured. Please Try Again Later");
          setReady(true);
        });
    } else {
      setReady(false);
      fetch(`${process.env.REACT_APP_API}/clinic/medications`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify(newMedication),
      })
        .then((response) => response.json())
        .then((response) => {
          setSuccess("New medication added successfully");
          setNewMedication({
            name: "",
            brand: "",
            dosage: "",
            fee: "",
          });
          if (response.success) {
            setSuccess("New medicatiton added successfully");
            fetchMedications();
          } else {
            setMessage(response.message);
          }
        })
        .catch((error) => {
          console.error(error);
          setMessage("Some Error Occured. Please Try Again Later");
          setReady(true);
        });
    }
  };

  useEffect(() => {
    fetchMedications();
  }, []);

  useEffect(() => {
    if (editMedication) setEditMode(true);
  }, [editMedication]);

  return (
    <>
      <main
        className={`mx-auto container flex flex-col p-4 font-font-2 tracking-wider ${
          ready ? "" : "hidden"
        }`}>
        <nav className="flex items-center border-b-2 border-background-2 pb-4 mx-10">
          <NavLink to="/">
            <img className="h-20" src={Logo} alt="GRO Track" />
          </NavLink>
          <h1 className="mx-auto mt-4 text-3xl text-text-2 font-font-2 font-bold">
            PACIFIC HAIR CENTER
          </h1>
        </nav>
        {message && <p className="mt-8 text-center text-red-600">{message}</p>}
        {success && (
          <p className="mt-8 text-center text-green-600">{success}</p>
        )}
        <section className="flex">
          <AdminSidebar />
          <div className="mx-auto">
            <form
              className="mt-4 flex flex-col"
              onSubmit={(event) => {
                event.preventDefault();
                handleSubmit();
              }}>
              <div className="flex justify-between items-center">
                <button
                  type="button"
                  className={`px-8 py-1 bg-accent-1 rounded-lg text-text-3 font-bold
              cursor-pointer focus:outline-none ${!editMode && "hidden"}`}
                  onClick={() => {
                    setEditMode(false);
                    setEditMedication(null);
                  }}>
                  Cancel
                </button>
                <p className="mx-24 text-text-2">SET UP MEDICATION</p>
                <button
                  className="px-8 py-1 bg-accent-1 rounded-lg text-text-3 font-bold
              cursor-pointer focus:outline-none">
                  {editMode ? "SAVE" : "ADD"}
                </button>
              </div>
              <div className="mx-auto mt-10 flex flex-col items-end">
                <div
                  className={`w-full md:w-96 px-2 ${
                    editMode ? "" : "hidden"
                  }`}></div>
                <label className="mt-4 flex items-center">
                  <p className="ml-2">Medication</p>
                  <input
                    type="text"
                    className="ml-6 w-40 md:w-96 px-2 py-1 bg-background-2 text-text-2 font-bold rounded-sm focus:outline-none"
                    value={editMode ? editMedication.name : newMedication.name}
                    onChange={(event) => {
                      editMode
                        ? setEditMedication({
                            ...editMedication,
                            name: event.target.value,
                          })
                        : setNewMedication({
                            ...newMedication,
                            name: event.target.value,
                          });
                    }}
                  />
                </label>
                <label className="mt-4 flex items-center">
                  <p className="ml-2">Brand Name</p>
                  <input
                    type="text"
                    className="ml-6 w-40 md:w-96 px-2 py-1 bg-background-2 text-text-2 font-bold rounded-sm focus:outline-none"
                    value={
                      editMode ? editMedication.brand : newMedication.brand
                    }
                    onChange={(event) => {
                      editMode
                        ? setEditMedication({
                            ...editMedication,
                            brand: event.target.value,
                          })
                        : setNewMedication({
                            ...newMedication,
                            brand: event.target.value,
                          });
                    }}
                  />
                </label>
                <div className="mt-4 flex">
                  <p className="ml-2 mt-1">Dosage</p>
                  <div className="ml-6 grid gap-4 w-40 md:w-96 md:grid-cols-2 mb-4">
                    <label className="flex items-center">
                      <input
                        type="text"
                        className="w-full px-2 py-1 bg-background-2 text-text-2 font-bold rounded-sm focus:outline-none"
                        value={
                          editMode
                            ? editMedication.dosage
                            : newMedication.dosage
                        }
                        onChange={(event) => {
                          editMode
                            ? setEditMedication({
                                ...editMedication,
                                dosage: event.target.value,
                              })
                            : setNewMedication({
                                ...newMedication,
                                dosage: event.target.value,
                              });
                        }}
                      />
                    </label>
                  </div>
                </div>
                <label className="ml-16 flex items-center self-start">
                  <p className="ml-2 mr-1">Fee</p>
                  <input
                    type="number"
                    className="ml-6 md:w-46 font-bold w-40 px-2 py-1 bg-background-2 text-text-2 rounded-sm focus:outline-none"
                    value={editMode ? editMedication.fee : newMedication.fee}
                    onChange={(event) => {
                      editMode
                        ? setEditMedication({
                            ...editMedication,
                            fee: event.target.value,
                          })
                        : setNewMedication({
                            ...newMedication,
                            fee: event.target.value,
                          });
                    }}
                  />
                </label>
              </div>
            </form>
            {medications.length > 0 && (
              <div className="mt-8">
                <h2 className="text-lg font-font-2 font-bold text-center">
                  MEDICATION LIST
                </h2>
                <div className="mt-4 bg-gray-800 p-4 px-8 grid grid-cols-3 gap-x-8 gap-y-4">
                  {medications.map((medication) => (
                    <button
                      key={medication.id}
                      className="bg-background-2 text-text-5 p-2 focus:outline-none"
                      onClick={() => setEditMedication(medication)}>
                      {medication.name}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>
      </main>
      <Loading message={"Loading Medication Details"} ready={ready} />
    </>
  );
}
